import React from "react";
import { useTranslation } from 'react-i18next';
import Sidebar from "../components/layout/Sidebar";
import { FaHome, FaHammer, FaBuilding, FaCity, FaTools, FaSun, FaClipboardList, FaHardHat } from 'react-icons/fa';

const Services = () => {
  const { t } = useTranslation();

  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: "80px" }}>
        <div className="container mt-5">
          <h1 style={{color: '#2c3e50', marginRight: '10px', fontSize: '70px' }}>{t('services.title')}</h1>
          
          <div className="row">
            <div className="col-md-6">
              <h2 style={{color: '#2c3e50', marginBottom: '20px', fontSize: '2rem'}}>{t('services.companyServices')}</h2>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaBuilding style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.newConstruction')}
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaHammer style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.renovation')}
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaHome style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.restoration')}
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaTools style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.plantEngineering')}
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaSun style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.photovoltaic')}
                </li>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  <FaHardHat style={{ color: '#2c3e50', marginRight: '10px', fontSize: '1.2em' }} />
                  {t('services.siteManagement')}
                </li>
              </ul>
            </div>
            
            <div className="col-md-6">
              <h2 style={{color: '#2c3e50', marginBottom: '20px', fontSize: '2rem'}}>{t('services.technicalServices')}</h2>
              
              <h3 style={{color: '#2c3e50', marginBottom: '15px', fontSize: '1.4rem'}}>{t('services.projectManagement')}</h3>
              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '25px' }}>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.timeManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.designManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.contractManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.procurementManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.constructionManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.defectPrevention')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.riskManagement')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.strategicAnalysis')}</li>
              </ul>
              
              <h3 style={{color: '#2c3e50', marginBottom: '15px', fontSize: '1.4rem'}}>{t('services.qualityManagement')}</h3>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.technicalDirection')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.qualityPlan')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.qualityDocumentation')}</li>
                <li style={{ marginBottom: '8px', fontSize: '1rem' }}>• {t('services.defectManagement')}</li>
              </ul>
            </div>
          </div>
        </div>
       {/*  <div className="container mt-5">
          <h2>Hai bisogno di una consulenza personalizzata?</h2>
          <p>
            Scopri "Studio Pastore" → <a href="/StudioPastore">
            <img
              src="https://res.cloudinary.com/dwc20azoo/image/upload/v1749198446/Logo_studio_pastore_trasparente_lgwsje.png"
              alt="Studio Pastore"
            />
          </a>
          </p>
         
        </div> */}
      </div>
    </>
  );
};

export default Services;
